export enum ChartType {
  DONUT = 'donut',
  H_BAR = 'h_bar',
  H_BAR_MULTI = 'h_bar_multi',
  H_BAR_STACK = 'h_bar_stack',
  KPI = 'kpi',
  LINE = 'line',
  LINE_MULTI = 'line_multi',
  V_BAR = 'v_bar',
  V_BAR_MULTI = 'v_bar_multi',
  V_BAR_STACK = 'v_bar_stack',
  V_BAR_STACK_LINE = 'v_bar_stack_line',
}
